import styled from "styled-components";

export const SubmitActionsContainer = styled.div`
  display: flex;
`;

export const VerticalSeparator = styled.div`
  height: 1.5rem;
`;

export const HorizontaSeparator = styled.div`
  width: 1rem;
`;

export const SpecialistCountersContainer = styled.div`
  display: flex;
`;

export const ErrorContainer = styled.div`
  padding: 1rem;
  background-color: #F6C1CA;
  color: #741121;
  font-family: Montserrat;
  margin-top: 1rem;
`;

export const ErrorTitle = styled.p`
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

export const ErrorText = styled.p`

`;

export const Label = styled.p`
  padding: 0;
  margin: 0;
  font-size: 0.9rem;
  font-family: Montserrat;
  font-weight: 500;
  margin-bottom: 0.2rem;
`;

export const SignatureChips = styled.div`
  border-radius: 0.25rem;
  border: 1px solid rgba(0 ,0, 0, 0.5);
  padding: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;

  &:hover {
    cursor: pointer;
  }
`;

export const SignatureEmptyMessage = styled.p`
  font-size: 1rem;
  color: #282828;
`;

export const SignatureChip = styled.span`
  background-color: #E7E7E7;
  color: #000;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
`;

export const SecondaryButton = styled.button`
  padding: 0.5rem 1rem;
  border: 1px solid #FF7417;
  background-color: transparent;
  color: #FF7417;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 0.25rem;
  opacity: ${props => props?.disabled ? 0.5 : 1};
  margin-top: 0.5rem;
  margin-right: auto;

  &:hover {
    cursor: pointer;
    filter: brightness(0.95);
  }
`;